import { useValues } from '@core/store'
import type { TAudioSimple } from '@core/models'

import { audioPlayerStore } from '../store/audioPlayerStore'

/** The currently-selected track, or `undefined` when the index is out of the playlist range. */
export const useActiveAudio = (): TAudioSimple | undefined => {
    const [playlist, activeAudioIndex] = useValues([
        audioPlayerStore.props.getPlaylist,
        audioPlayerStore.props.getActiveAudioIndex,
    ])

    const { items } = playlist

    if (activeAudioIndex >= 0 && activeAudioIndex < items.length) {
        return items[activeAudioIndex]
    }

    return undefined
}
